import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import YoungPersonForm from '../components/YoungPersonForm';
import Footer from '../components/Footer';

const YoungPerson = () => {
  return (
    <div className="YoungPerson bg-[#faf8f5] min-h-screen">
      <Header />
      <div className="mt-32 sm:mt-36 lg:mt-32">
        <Hero
          image="https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=2400&q=80"
          heightClass="min-h-[50vh] sm:min-h-[60vh] lg:min-h-[70vh]"
          position={{ xs: 'center', sm: 'center', md: 'center', lg: 'center', xl: 'center', '2xl': 'center' }}
          fit="cover"
          overlay={true}
        />

        <section className="py-16 px-6 bg-[#faf8f5]">
          <div className="max-w-5xl mx-auto text-center space-y-6 text-[#2c5f7c]">
            <p className="text-sm uppercase tracking-[0.3em] text-orange-500">Young Person</p>
            <h1 className="text-4xl md:text-5xl font-light">Need to talk to someone?</h1>
            <p className="text-lg leading-relaxed">
              If you&apos;re staying in a Testa Care home you can use this page to reach our support team directly.
              Whether it&apos;s a quick update, something that&apos;s worrying you or just a friendly hello, we&apos;re
              always here to listen.
            </p>
          </div>
        </section>

        <YoungPersonForm />

        <section className="py-16 px-6 bg-white">
          <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 text-[#2c5f7c]">
            <div>
              <h2 className="text-2xl font-semibold mb-4">Prefer to speak to someone?</h2>
              <p>
                Talk to your key worker or Registered Manager at your home. They can help straight away and get our wider
                team involved if needed. You can also reach the Testa Care central support team on{' '}
                <a className="text-orange-500 font-semibold" href="tel:+447767054238">
                  +44 (0)7767 054238
                </a>
                .
              </p>
            </div>
            <div>
              <h2 className="text-2xl font-semibold mb-4">Safeguarding &amp; whistleblowing</h2>
              <p>
                If you feel unsafe or uncomfortable talking to your home team, you can speak confidentially with the
                safeguarding lead by emailing{' '}
                <a className="text-orange-500 font-semibold" href="mailto:safeguarding@testacare.co.uk">
                  safeguarding@testacare.co.uk
                </a>
                .
              </p>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default YoungPerson;
